<template>

          <div id="carouselSetupWizard" class="carousel slide" >
            <div class="carousel-inner">
              <div class="carousel-item active p-1">

                        <div class="form-group row mb-0">

                            <div class="col-md-6 mb-3">
                                <label for="first_name" class="form-label lead">First Name</label>
                                <input id="first_name" ref="input_first_name" v-model="input_first_name" type="text" class="form-control" name="first_name" required autocomplete="first_name" autofocus>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label for="last_name" class="form-label lead">Last Name</label>
                                <input id="last_name" ref="input_last_name" v-model="input_last_name" type="text" class="form-control" name="last_name" required autocomplete="last_name" >

                            </div>
                        </div>
     
                        <div class="form-group row mb-0">

                            <div class="col-md-6 mb-3 ">
                                <label for="company_name" class="form-label lead">Company Name</label>
                                <input id="company_name" ref="input_company_name" v-model="input_company_name" type="text" class="form-control" name="company_name" required autocomplete="company_name" >

                            </div>

                            <div class="col-md-6 mb-3">
                                <label for="position" class="form-label lead">Position</label>
                                <input id="position" ref="input_position" v-model="input_position" type="text" class="form-control" name="position" required autocomplete="position" >

                            </div>
                        </div>

                        <div class="form-group row mb-0">
                            <div class="col-md-4 pt-3">
                                <button type="button" @click="signupNext" class="btn btn-primary btn-lg btn-block">
                                    Next
                                </button>
                            </div>
                        </div>

              </div>

              <div class="carousel-item p-1">

                        <div class="form-group row mb-0">

                            <div class="col-md-6 mb-3">
                                <label for="email" class="form-label lead">E-Mail Address</label>
                                <input id="email" ref="input_email" v-model="input_email" type="email" class="form-control" name="email" required autocomplete="email">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="telephone"  class="form-label lead">Mobile Number</label>
                                <vue-tel-input class="form-control" id="telephone" ref="input_telephone" v-model="input_telephone" name="telephone" placeholder="" mode="international" :required="true"></vue-tel-input>

                            </div>

                        </div>
                
                        <div class="form-group row mb-0">

                            <div class="col-md-6 mb-3">
                                <label for="password" class="form-label lead">Password</label>
                                <input id="password" ref="input_password" v-model="input_password" type="password" class="form-control" name="password" required autocomplete="new-password" >

                            </div>

                            <div class="col-md-6 mb-3">
                                <label for="password-confirm" class="form-label lead">Confirm Password</label>
                                <input id="password-confirm" ref="input_password_confirm" v-model="input_password_confirm" type="password" class="form-control" name="password_confirmation" required autocomplete="new-password" >
                            </div>
                        </div>
                        <div class="form-group row mb-0">

                            <div class="col-md-12 mb-3">
                                <label for="terms-conditions-confirm" class="mb-0 text-center text-xl-center mx-auto d-block">I confirm that I have read and agree to Sizzle Deck's <a class="d-block d-sm-inline" href="https://www.sizzledeck.com/legal/" target="blank">Terms of Use and Privacy Policy</a> &nbsp;&nbsp; <input name="terms_conditions" value="confirmed" type="checkbox" class="align-middle" id="terms-conditions-confirm" ref="input_terms_conditions_confirm" v-model="input_terms_conditions_confirm" required></label>
                            </div>

                        </div>



                        <div class="d-flex flex-row-reverse justify-content-between">
                            <div class="col-md-4 pt-3 p-0">
                                <button type="button" @click="signupSubmit" class="btn btn-primary btn-lg btn-block">
                                    Next
                                </button>
                            </div>
                            <div class="col-1">
                              
                            </div>
                            <div class="col-md-4 pt-3 p-0">
                                <button type="button" @click="signupPrev" class="btn btn-secondary btn-lg btn-block">
                                    Back
                                </button>
                            </div>
                        </div>

              </div>

            </div>
          </div>
          </div>

</template>

<script>

import axios from 'axios';
import Noty from 'noty';

  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '1497098367158399');
  fbq('track', 'PageView');

  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

export default {

  mounted() {
        $('.carousel').carousel({
          interval: false,
          wrap: false,
        });

        gtag('js', new Date());
        gtag('config', process.env.MIX_GOOGLE_ANALYTICS_ID, { // GA Tracking ID
            send_page_view: false
        });

      },
      data: function(){
        return {                
          csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
          input_first_name: null,
          input_last_name: null,
          input_company_name: null,
          input_position: null,
          input_email: null,
          input_telephone: null,
          input_password: null,
          input_password_confirm: null,
          input_terms_conditions_confirm: null,
        }
      },
      methods:{

        signupNext: function(){

          var vm = this;

          if(vm.$refs.input_first_name.checkValidity() &&
             vm.$refs.input_last_name.checkValidity() &&
             vm.$refs.input_company_name.checkValidity() &&
             vm.$refs.input_position.checkValidity()){
            
            $('#carouselSetupWizard').carousel('next');

          }else{
            vm.showNoty('error','Please Complete All Fields',2000);
          }

          

        },
        signupPrev: function(){

          $('#carouselSetupWizard').carousel('prev');

        },
        signupSubmit: function(){

            var vm = this;

            if(!vm.$refs.input_email.checkValidity()){
              vm.showNoty('error','Please enter a valid Email Address. ',2000);
              return false;
            }

            if(!vm.input_telephone){
              vm.showNoty('error','Please enter a valid Mobile Number. ',2000);
              return false;
            }

            if(!vm.$refs.input_password.checkValidity()){
              vm.showNoty('error','Please enter a Password. ',2000);
              return false;
            }            

            if(vm.input_password !== vm.input_password_confirm){
              vm.showNoty('error','Passwords don\'t match. ',2000);
              return false;
            }

            if(!vm.$refs.input_terms_conditions_confirm.checkValidity()){
              vm.showNoty('error','Please confirm you agree to our Terms of Use and Privacy Policy. ',2000);
              return false;
            }            

            axios.post('/register',{
              first_name:vm.input_first_name,
              last_name:vm.input_last_name,
              company_name:vm.input_company_name,
              position:vm.input_position,
              telephone:vm.input_telephone,
              email:vm.input_email,
              password:vm.input_password,
              password_confirmation:vm.input_password_confirm,
              terms_conditions:vm.input_terms_conditions_confirm
            }).then(response => {

                if(response.status === 201){
                  vm.redirectToSetup();
                }else{
                  vm.showNoty('warning',response.statusText,false);
                }               

            }).catch(function(error){

              if(error.response.status === 422){

                var errors = [];
                var pageback = false;
                for (var error_input in error.response.data.errors) {
                  for (var error_message_key in error_input) {
                    if(error.response.data.errors[error_input][error_message_key]){
                      vm.showNoty('error',error.response.data.errors[error_input][error_message_key],2000);
                      if(
                        error_input == 'first_name' ||
                        error_input == 'last_name' ||
                        error_input == 'company_name' ||
                        error_input == 'position'
                        ){
                        pageback = true;
                      }
                    }
                  }
                }

                if(pageback){
                  vm.signupPrev();
                }

                

              }else{
                vm.handleError(error);
              }

            });

        },
        redirectToSetup: function(){

          var vm = this;

          // Facebook Track
          fbq('track', 'StartTrial',{
            em: vm.input_email,
            name: vm.input_first_name + ' ' + vm.input_last_name
          });

          // Google Analytics Track
          gtag('event', 'StartTrial');


          // Redirect
          window.location.href = '/setup';

        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
            }

        },
        showNoty: function(type='warning',message='',timeout=false){
          new Noty({
                    text: message,
                    type: type,
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: timeout
                }).show();
        },
        showGeneralErrorNoty: function(){
          new Noty({
                    text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
                    type: 'error',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: false
                }).show();
        },
        showLoggedOutNoty: function(){
          new Noty({
              text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
              type: 'error',
              theme: 'bootstrap-v4',
              layout: 'topCenter',
              timeout: false
          }).show();
        },  



      }
}
</script>
